import Image from "next/image";
import styles from "./result.module.scss";
import { useEffect, useRef, useState } from "react";

const SportCardsGeneratorServiceResult = ({ sportCardsState }) => {
	const prewRef = useRef(null)
	const [chenge, setChange] = useState(true)

	const handleResize = () => {
		setChange(true)
		setTimeout(() => {
			if (prewRef.current === null || sportCardsState.template === null) return;
			let scale = prewRef.current.offsetWidth / 600;

			const card = prewRef.current.querySelector(".card")

			if (prewRef.current.offsetHeight < (837 * scale)) {
				scale = prewRef.current.offsetHeight / 850
			}

			card.style.transform = `scale(${scale})`;

			setChange(false)
		}, 1000)
	}

	useEffect(() => {
		window.addEventListener("resize", handleResize)
		return () => window.removeEventListener("resize", handleResize)
	}, [])

	useEffect(() => {
		setChange(true)
		handleResize();
	}, [sportCardsState.template])

	useEffect(() => {
		if (!sportCardsState.template) return;

		const updateElement = (selector, styles = null, text = null, defaultText = null) => {
			const element = document.querySelector(`.result ${selector}`);
			if (!element) return;

			if (styles) {
				Object.assign(element.style, styles);
			}

			if (text !== null) {
				element.innerHTML = text || defaultText;
			}
		};

		const commonImageStyles = {
			backgroundSize: 'cover',
			backgroundPosition: 'center',
			backgroundRepeat: 'no-repeat'
		};

		// Background
		if (sportCardsState.background?.image_url) {
			updateElement('.card', {
				backgroundImage: `url(${sportCardsState.background.image_url})`
			});
		}

		// Pose
		if (sportCardsState.pose?.name) {
			updateElement('.selfie', {
				...commonImageStyles,
				backgroundImage: `url(${sportCardsState.pose.name})`
			});
		}

		// Logo 1
		if (sportCardsState.logo[1]) {
			updateElement('.logo_one', {
				...commonImageStyles,
				backgroundImage: `url(${sportCardsState.logo[1].image_url})`
			});
			updateElement('.logo_one__text', null, '');
		}

		// Logo 2
		if (sportCardsState.logo[2] && sportCardsState.template.has_logo2) {
			updateElement('.logo_two', {
				...commonImageStyles,
				backgroundImage: `url(${sportCardsState.logo[2].image_url})`
			});
			updateElement('.logo_two__text', null, '');
		}

		// Flag
		if (sportCardsState.flag?.image_url && sportCardsState.template.has_flag) {
			updateElement('.flag', {
				...commonImageStyles,
				backgroundImage: `url(${sportCardsState.flag.image_url})`
			});
		}

		// Text fields
		const textFields = {
			'.position__text': [sportCardsState.position, 'position'],
			'#first_name': [sportCardsState.name, 'First name'],
			'#last_name': [sportCardsState.surname, 'Last name']
		};

		Object.entries(textFields).forEach(([selector, [value, defaultValue]]) => {
			updateElement(selector, null, value, defaultValue);
		});

		// Numbers
		if (sportCardsState.template.has_num1) {
			updateElement('#number_one_number', null, sportCardsState.num1, '36');
			updateElement('#number_one_text', null, sportCardsState.desc1, 'batting');
		}

		if (sportCardsState.template.has_num2) {
			updateElement('#number_two_number', null, sportCardsState.num2, '56');
			updateElement('#number_two_text', null, sportCardsState.desc2, 'batting');
		}

	}, [sportCardsState]);

	return (
		<div className={`${styles.result} ${sportCardsState.template !== null ? styles.templateWrapper : ""}`}>
			{sportCardsState.template !== null && (
				<div className={`${styles.template} result`}>
					<style dangerouslySetInnerHTML={{ __html: sportCardsState.template.css.replace(/\.(?=[a-zA-Z][\w-]*\s*{)/g, '.result .') }} />
					<div ref={prewRef} className={`${styles.card} ${chenge ? styles.chenge : ""}`} dangerouslySetInnerHTML={{ __html: sportCardsState.template.html }} />
				</div>
			)}

			{sportCardsState.template === null && (
				<Image className={styles.empty} src={"/sport_cards/empty.png"} alt="empty" width="552" height="686" quality={99} />
			)
			}
		</div>
	);
};

export default SportCardsGeneratorServiceResult;
